import React, { Component } from 'react';
import MensajeF from '../components/Mensaje_Flotante/MensajeF';
import Footer from '../components/Principal/Footer';
import Header from '../components/Principal/Header';
import Seccion1 from '../components/AvisoPrivacidad/Seccion1';
import Seccion2 from '../components/AvisoPrivacidad/Seccion2';

class AvisoPrivacidad extends Component {

    render() {
        return (
            <React.Fragment>
                <Header id={2} />
                <MensajeF />
                <Seccion1 />
                <Seccion2 />
                <Footer />
            </React.Fragment>
        )
    }
}

export default AvisoPrivacidad;